import { Component, PropTypes } from 'react';
import classNames from 'classnames';

class TableBodyRow extends Component {
    constructor(props) {
        super(props);
        this.clickNum = 0;
    }

    rowClick(e) {
        if (e.target.tagName !== 'INPUT' &&
            e.target.tagName !== 'SELECT' &&
            e.target.tagName !== 'A' &&
            e.target.tagName !== 'STRONG' &&
            e.target.tagName !== 'TEXTAREA') {
            this.props.onRowClick(e);
        }
    }

    render() {
        const { children } = this.props;
        const className = classNames('cn-table__row', this.props.className);

        return (
            <tr className={className}>
                {children}
            </tr>
        );
    }
}

TableBodyRow.propTypes = {
    children: PropTypes.node
};

TableBodyRow.defaultProps = {
    selected: false
};

export default TableBodyRow;



// WEBPACK FOOTER //
// ./app/components/table/body_row.jsx